import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import { makeHitArea } from 'Engine/utils/makeHitArea';
import eEventTypes from '../../enums/eEventTypes';

export default class PaytableControls extends FlashLib.MovieClip{
  constructor(data, displayData) {
    super(data, displayData);

    this.init();
    this.addActions();

    this.interactive = true;
    this.range = null;
    this.currentPage = 1;
  }

  init() {
    this.btnLeft = this.getChildByName('btnLeft');
    this.btnRight = this.getChildByName('btnRight');
    this.btnBack = this.getChildByName('btnBack');
    makeHitArea(this.btnLeft);
    makeHitArea(this.btnRight);
    makeHitArea(this.btnBack);
    this.btnBack.enabled = true;
  }

  addActions() {
    this.btnLeft.on('pointertap', this.onLeftClick, this);
    this.btnRight.on('pointertap', this.onRightClick, this);
    this.btnBack.on('pointertap', this.onBackClick, this);
  }

  checkButtonsEnabled() {
    this.btnLeft.enabled = this.range.indexOf(this.currentPage) > 0;
    this.btnRight.enabled = this.range.indexOf(this.currentPage) < this.range.length - 1;
  }

  onBackClick() {
    GlobalDispatcher.dispatch(eEventTypes.EET_PAYTABLE__BACK_CLICK);
    GlobalDispatcher.dispatch(eEventTypes.EBET_PAYTABLE__BACK_CLICK);
  }

  onLeftClick() {
    this.currentPage--;
    GlobalDispatcher.dispatch(eEventTypes.EET_PAYTABLE__CHANGE_PAGE, this.currentPage);
    this.checkButtonsEnabled();
  }

  onRightClick() {
    this.currentPage++;
    GlobalDispatcher.dispatch(eEventTypes.EET_PAYTABLE__CHANGE_PAGE, this.currentPage);
    this.checkButtonsEnabled();
  }

  setRange(array) {
    this.range = array;
    this.checkButtonsEnabled();
  }
}
